interface SourcingInfoFilterProps {
  hasOrderNumber: boolean;
  onHasOrderNumberChange: (value: boolean) => void;
  hasTrackingNumber: boolean;
  onHasTrackingNumberChange: (value: boolean) => void;
}

export function SourcingInfoFilter({
  hasOrderNumber,
  onHasOrderNumberChange,
  hasTrackingNumber,
  onHasTrackingNumberChange,
}: SourcingInfoFilterProps) {
  return (
    <div className="d-flex align-items-center gap-3">
      <label className="d-flex align-items-center gap-1 mb-0" style={{ fontSize: '13px' }}>
        <input type="checkbox" checked={hasOrderNumber} onChange={(e) => onHasOrderNumberChange(e.target.checked)} />
        <span>Order#</span>
      </label>
      <label className="d-flex align-items-center gap-1 mb-0" style={{ fontSize: '13px' }}>
        <input
          type="checkbox"
          checked={hasTrackingNumber}
          onChange={(e) => onHasTrackingNumberChange(e.target.checked)}
        />
        <span>Tracking#</span>
      </label>
    </div>
  );
}
